import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import EnergyServicesNavigation from "../components/EnergyServicesNavigation";
import Loading from "../components/Loading";
import PageTitle from "../components/PageTitle";
import ComparingBanner from "../components/ComparingBanner";
import RankingsTitle from "../components/RankingsTitle";
import RankingsPanel from "../components/RankingsPanel";
import RankingsChart from "../components/RankingsChart";
import PopupWrapper from "../components/PopupWrapper";
import { rankingsActions } from "../_actions";
import { connect } from "react-redux";

class EnergyServicesRankings extends Component {
  constructor(props) {
    super(props);
    let user = JSON.parse(localStorage.getItem("user"));
    const unix = Math.round(+new Date() / 1000);
    this.props.dispatch(rankingsActions.getWeeklyDetail(user, unix));
    this.props.dispatch(rankingsActions.getMonthlyDetail(user, unix));
  }

  render() {
    const { fetchingDetail, weeklyDetail, monthlyDetail } = this.props.rankings;

    return (
      <div>
        <Header
          title={"My Home"}
          backTitle={"Dashboard"}
          backHref={"/"}
          isHomeView={true}
        />
        <PageTitle
          title={"Ranking"}
          subTitle={"Comparing a house just like yours."}
        />
        <EnergyServicesNavigation {...this.props.location} />
        <div className={css(styles.container)}>
          <PopupWrapper />
          {fetchingDetail && <Loading />}
          {!fetchingDetail && weeklyDetail.period && monthlyDetail.period && (
            <div>
              <ComparingBanner />
              <RankingsTitle {...weeklyDetail} />
              <RankingsChart {...weeklyDetail} />
              <RankingsTitle {...monthlyDetail} />
              <RankingsChart {...monthlyDetail} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { fetchingDetail } = state.rankings;
  const { alert } = state;
  const rankings = state.rankings;
  return {
    fetchingDetail,
    alert,
    rankings
  };
}

export default connect(mapStateToProps)(EnergyServicesRankings);
